import React from 'react';
export default function BeretSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="20" cy="24" rx="14" ry="4" fill="#5D4037" />
      <ellipse cx="20" cy="20" rx="12" ry="8" fill="#E53935" />
      <ellipse cx="20" cy="18" rx="10" ry="5" fill="#EF5350" />
      <circle cx="20" cy="12" r="2" fill="#B71C1C" />
    </svg>
  );
}
